import { ClientItem } from 'owa-mail-store';

export default {
    InlineTranslationMessageTranslated: {
        datapoint: {
            name: 'InlineTranslationMessageTranslated',
            cosmosOnlyData: (item: ClientItem) => item.ItemId.Id,
        },
    },

    InlineTranslationMessageUntranslated: {
        datapoint: {
            name: 'InlineTranslationMessageUntranslated',
            cosmosOnlyData: (item: ClientItem) => item.ItemId.Id,
        },
    },
};
